/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styles from "./Styles.module.scss";
import { useParams, useNavigate } from "react-router-dom";
import { Breadcrumbs, Container, Grid, Link as BCLink } from "@mui/material";
import { NavigateNext } from "@mui/icons-material";
import axios from "../../axios";
import { default as OrderDetailsContainer } from "../../components/MyAccount/OrderDetails";
import MiniLoading from "../../components/MiniLoading";
import { useTranslation } from "react-i18next";
import usePermissionGuard from "../../hooks/usePermissionGuard";

const StoreOrderDetail = () => {
  usePermissionGuard("view_orders");
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios
      .get("/admin/store/dashboard/orders/" + id)
      .then((r) => setOrder(r.data.data))
      .catch(() => setError(true));
  }, []);

  return (
    <div>
      <Container sx={{ pb: "1rem" }}>
        <div role="presentation">
          <Breadcrumbs
            aria-label="breadcrumb"
            separator={<NavigateNext fontSize="small" />}
            sx={{ p: "14px 0" }}
          >
            <BCLink className={styles.brdHov} underline="none" color="inherit" href="/" fontSize="14px">
              {t("Home")}
            </BCLink>
            <BCLink className={styles.brdHov} underline="none" color="inherit"
              onClick={() => navigate("/store/dashboard")} sx={{ cursor: "pointer" }} fontSize="14px">
              Dashboard
            </BCLink>
            <BCLink className={styles.brdHov} underline="none" color="inherit"
              onClick={() => navigate("/store/orders")} sx={{ cursor: "pointer" }} fontSize="14px">
              {t("Orders")}
            </BCLink>
            <BCLink underline="none" color="text.primary" aria-current="page" fontSize="14px">
              {t("Order")} #{order?.OrderNumber ?? "—"}
            </BCLink>
          </Breadcrumbs>
        </div>

        <Grid container item spacing={2} sx={{ justifyContent: "center" }}>
          <Grid container item>
            {error ? (
              <div style={{ padding: "2rem", color: "#c62828" }}>{t("Order does not exists.")}</div>
            ) : order == null ? (
              <MiniLoading />
            ) : (
              <OrderDetailsContainer data={order} />
            )}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default React.memo(StoreOrderDetail);
